import React from "react";
import OfferTemplatePage from "./../pages/OfferTemplatePage";

const OfferSellPage = () => {
  return <OfferTemplatePage type="sell" />;
};

export default OfferSellPage;
